export default "__VITE_ASSET__Du_yOX61__"